import { render, staticRenderFns } from "./ReferenceCommentListTable.vue?vue&type=template&id=0a1be365&scoped=true&"
import script from "./ReferenceCommentListTable.vue?vue&type=script&lang=ts&"
export * from "./ReferenceCommentListTable.vue?vue&type=script&lang=ts&"
import style0 from "./ReferenceCommentListTable.vue?vue&type=style&index=0&id=0a1be365&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1be365",
  null
  
)

export default component.exports